module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-square product",
    staticStyle: {
      "border": "0"
    }
  }, [_c('div', {
    ref: "img",
    staticClass: "product-img",
    style: ({
      backgroundImage: ("url(" + _vm.image + ")"),
      height: (_vm.imgHeight + "px")
    }),
    on: {
      "click": _vm.handleClick
    }
  }, [(_vm.flag !== '') ? _c('span', {
    staticClass: "product-flag"
  }, [_vm._v(_vm._s(_vm.flag))]) : _vm._e()]), _vm._v(" "), _c('h3', {
    staticClass: "tl product-title m1000",
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._v("\n    " + _vm._s(_vm.name) + "\n    "), (_vm.tip !== '') ? _c('span', {
    staticClass: "product-tip"
  }, [_vm._v("\n      " + _vm._s(_vm.tip) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-intro"
  }, [_c('p', {
    staticClass: "product-content tl p0010"
  }, [_vm._v(_vm._s(_vm.content))]), _vm._v(" "), (_vm.oldprice > 0 && _vm.oldprice != _vm.price) ? _c('p', {
    staticClass: "product-content tl",
    staticStyle: {
      "text-decoration": "line-through"
    }
  }, [_vm._v("\n      原价 " + _vm._s(_vm.oldprice) + " " + _vm._s(_vm.priceUnit) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex-box tl product-dock",
    staticStyle: {
      "align-self": "flex-end"
    }
  }, [_c('div', {
    staticClass: "flex-item-1 color-highlight font-md",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_c('span', {
    staticClass: "font-sm"
  }, [_vm._v(_vm._s(_vm.pricePreUnit))]), _vm._v(" " + _vm._s(_vm.price) + "\n      "), (_vm.priceUnit !== '') ? _c('span', {
    staticClass: "price-unit"
  }, [_vm._v(_vm._s(_vm.priceUnit))]) : _vm._e()]), _vm._v(" "), (_vm.canbuy) ? _c('div', {
    staticClass: "flex-item",
    staticStyle: {
      "padding-top": "2px"
    }
  }, [_c('div', {
    staticClass: "flex-box number",
    staticStyle: {
      "width": "80px"
    }
  }, [(_vm.stock > 0) ? _c('bo-number', {
    ref: "number",
    attrs: {
      "max": _vm.max,
      "value": _vm.amountSelf
    },
    on: {
      "on-change": _vm.buy
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.stock <= 0) ? _c('span', {
    staticClass: "font-light font-sm p1000",
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("库存不足")]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-14da0ce1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/other/product/product.vue
// module id = 226
// module chunks = 7